"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PatientDetailSchema", {
    enumerable: true,
    get: function() {
        return PatientDetailSchema;
    }
});
const _zod = require("zod");
const _allergystatus = require("./allergy-status");
const _patientalert = require("./patient-alert");
const _patientcreate = require("./patient-create");
const _patientlist = require("./patient-list");
const PatientDetailSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    mrn: _zod.z.string(),
    givenName: _zod.z.string(),
    middleName: _zod.z.string().nullable(),
    familyName: _zod.z.string(),
    sex: _zod.z.enum([
        'F',
        'M'
    ]),
    birthDate: _zod.z.string().date(),
    philhealthPin: _patientlist.PhilHealthPinSchema.nullable(),
    alerts: _zod.z.array(_patientalert.PatientAlertSchema),
    allergies: _zod.z.array(_zod.z.string()),
    allergyStatus: _allergystatus.AllergyStatusSchema,
    allergyStatusRecordedAt: _zod.z.string().datetime({
        offset: true
    }).nullable(),
    allergyStatusRecordedByName: _zod.z.string().nullable(),
    mobileNumber: _zod.z.string(),
    civilStatus: _patientcreate.CivilStatusSchema.nullable(),
    address: _zod.z.string().nullable(),
    emergencyContact: _zod.z.object({
        name: _zod.z.string(),
        relationship: _zod.z.string().nullable(),
        mobile: _zod.z.string()
    }).strict().nullable(),
    philsysOnFile: _zod.z.boolean(),
    fpeRecordedAt: _zod.z.string().datetime({
        offset: true
    }).nullable(),
    createdAt: _zod.z.string().datetime({
        offset: true
    }),
    updatedAt: _zod.z.string().datetime({
        offset: true
    })
}).strict();
